import { SimpleForm, NumberInput, Button, useNotify, useRefresh, SaveButton } from "react-admin";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { useNotifyError } from "utils/useNotifyError";

const FeesEditForm = ({ record, setIsEditing }) => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSave = async data => {
    const payload = {
      documentProcessingFee: data.documentProcessingFee,
      dailyTrainingFee: data.dailyTrainingFee,
      certificateIssueFee: data.certificateIssueFee,
      duplicateCertificateIssueFee: data.duplicateCertificateIssueFee,
    };

    try {
      await dataProvider.customRequest(specialistRequests.updateAdvancedSpecializationFees(record.id), payload, "PUT");
      notify("Таксите са обновени успешно", { type: "success" });
      setIsEditing(false);
      refresh();
    } catch (err) {
      notifyError(err);
    }
  };
  return (
    <SimpleForm
      toolbar={false}
      onSubmit={handleSave}
      defaultValues={record?.fee}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="documentProcessingFee"
            label="Такса за обработка на документи"
            fullWidth
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="dailyTrainingFee"
            label="Такса за дневно обучение"
            fullWidth
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="certificateIssueFee"
            label="Такса за издаване на сертификат"
            fullWidth
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="duplicateCertificateIssueFee"
            label="Такса за дубликат на сертификат"
            fullWidth
            onWheel={e => e.target.blur()}
          />
        </Grid>
      </Grid>
      <Grid sx={{ display: "flex", gap: 3, mt: 3 }}>
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          size="small"
          label="Откажи"
          onClick={() => setIsEditing(false)}
        />
        <SaveButton
          label="Запази"
          size="small"
        />
      </Grid>
    </SimpleForm>
  );
};

export default FeesEditForm;
